import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import menu from '../components/menu'

Vue.use(VueRouter)

const ifAuth = (to, from, next) => {
  if (!localStorage.getItem('loadSiteNew')) localStorage.setItem('loadSiteNew', 'abaata')

  next()
}
const routes = [
  {
    path: '/',
    name: 'selectSite',
    component: () => import(/* webpackChunkName: "about" */ '../components/selectSite')
  },
  {
    path: '/:site/',
    alias: '/1',
    name: 'Abaata',
    component: Home,
    beforeEnter: ifAuth
  },
  {
    path: '/:site/menu',
    name: 'menu',
    component: menu,
    beforeEnter: ifAuth
  },
  {
    path: '/:site/about',
    alias: '/2',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/important.vue'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/about/awards',
    alias: '/3',
    name: 'Awards',
    component: () => import('../views/Awards.vue'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/about/gallery',
    alias: '/4',
    name: 'Gallerys',
    component: () => import('../views/Gallerys.vue'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/about/web-cams',
    name: 'webcam',
    component: () => import('../views/webcam.vue'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/about/feedback',
    redirect: to => ({ name: 'feedback', params: { site: to.params.site } }),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/gallery/:id',
    name: 'Gallery',
    component: () => import('../views/Gallery.vue'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/afisha/',
    alias: '/5',
    name: 'Afisha',
    component: () => import('../views/afisha/Afisha.vue'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/offers',
    name: 'Offers',
    component: () => import('../views/Offers'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/offers/:id',
    name: 'Offers',
    component: () => import('../views/Offers'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/offer/:id',
    alias: '/6',
    name: 'offer',
    component: () => import('../views/afisha/offer'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/restaurants',
    name: 'restaurants',
    component: () => import('../views/Restaurants'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/restaurant/:id',
    name: 'restaurant',
    component: () => import('../views/Restaurant'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/services',
    name: 'services',
    component: () => import('../views/Services'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/spa',
    name: 'spa',
    component: () => import('../views/Services'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/service/:id',
    name: 'service',
    component: () => import('../views/Service'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/special-offers',
    alias: '/7',
    name: 'Specoffers',
    component: () => import('../views/specoffers/Specoffers'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/important',
    alias: '/8',
    name: 'important',
    component: () => import('../views/important'),
    beforeEnter: ifAuth
  },
  {
    //path: '/booking',
    path: '/:site/booking/:start?/:end?/:guests?/:children?',
    name: 'booking',
    component: () => import('../views/booking'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/transfer',
    alias: '/9',
    name: 'orderTransfer',
    component: () => import('../views/order/orderTransfer'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/docs',
    alias: '/10',
    name: 'docs',
    component: () => import('../views/docs'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/feedback',
    alias: '/11',
    name: 'feedback',
    component: () => import('../views/feedback'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/about/contacts',
    name: 'contacts',
    component: () => import('../views/contacts'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/price',
    name: 'price',
    component: () => import('../views/price'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/blog',
    alias: '/12',
    name: 'blog',
    component: () => import('../views/blog'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/hair-clinic',
    name: 'hair-clinic',
    component: () => import('../views/hairClinic'),
    beforeEnter: ifAuth
  },
  {
    path: '/:site/*',
    name: 'article',
    component: () => import('../views/cartBlog'),
    beforeEnter: ifAuth
  }
]

// Сборка для amarihotel.ru (VUE_APP_SITE=amari): сайт без префикса /amari/. Адреса вида /rooms и /amari/rooms
// ведут на одну страницу, а /amari/... сразу перенаправляется на короткий адрес. Остальной код сайта по-прежнему
// строит ссылки с префиксом отеля, поэтому показываемые адреса (href) укорачиваются в router.resolve.
const AMARI_MODE = process.env.VUE_APP_SITE === 'amari'

const siteRoutes = AMARI_MODE
  ? routes
    .filter(r => r.name !== 'selectSite')   // выбора отеля на этом домене нет: корень сайта это главная Amari
    .map(r => ({ ...r, path: r.path.replace(/^\/:site(?=\/|\*|$)/, '/:site(amari)?'), alias: undefined }))
    .filter(r => r.path.startsWith('/:site(amari)?'))
  : routes

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: siteRoutes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { selector: to.hash, behavior: 'smooth' }
    return { x: 0, y: 0 }
  }
})

if (AMARI_MODE) {
  router.beforeEach((to, from, next) => {
    const prefixed = to.path.match(/^\/amari(\/.*)?$/)
    if (prefixed) return next({ path: prefixed[1] || '/', query: to.query, hash: to.hash, replace: true })
    to.params.site = 'amari'
    next()
  })
  const resolve = router.resolve.bind(router)
  router.resolve = (...args) => {
    const r = resolve(...args)
    r.href = r.href.replace(/^\/amari(?=\/|$)/, '') || '/'
    return r
  }
}

export default router
